function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var OTHER_FEE_REGEX = /^(.*):[\s\D]*([0-9,.]*)(?:(?:[\s\S]*?)(?:.*\sper\s(\w*)|(.*)))?\s*$/;
/**
 * This functions receives an array of string (ie: "Administrative fees: $123 per year")
 * We then extract "Administrative fees", "123" & "year"
 * Anything else is extracted as extra (ie: "(one time)" in "Administrative fees: $123 (one time)")
 */
export function extractOtherFees(fees) {
  return fees ? fees.reduce(function (acc, fee) {
    var matches = fee.match(OTHER_FEE_REGEX);
    if (matches) {
      var _matches$;
      var feeInfo = {
        title: matches[1] || '',
        value: matches[2].replace(',', '') || '',
        timeframe: matches[3],
        extra: (_matches$ = matches[4]) === null || _matches$ === void 0 ? void 0 : _matches$.trim()
      };
      if (feeInfo.title && feeInfo.value) {
        return [].concat(_toConsumableArray(acc), [feeInfo]);
      }
    }
    return acc;
  }, []) : [];
}
export function filterSmallFees(fees) {
  return fees.filter(function (_ref) {
    var value = _ref.value;
    return parseFloat(value) >= 10.0;
  });
}